"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_1 = require("@ethersproject/bignumber");
const tectonic_contract_types_1 = require("@cronos-labs/tectonic-contract-types");
const base_1 = require("../base");
const constant_1 = require("../constant");
const util_1 = require("../util");
class TonicModule extends base_1.TectonicSDKModule {
    async tonicAccrued(ownerAddress) {
        const tCore = this.getTectonicCore();
        return await tCore.tonicAccrued(ownerAddress);
    }
    async tonicDistributeRateForSupply(tTokenAddress) {
        // TODO: Check if token is supported
        const tCore = this.getTectonicCore();
        return tCore.tonicSupplySpeeds(tTokenAddress);
    }
    async tonicDistributeRateForBorrow(tTokenAddress) {
        // TODO: Check if token is supported
        const tCore = this.getTectonicCore();
        return tCore.tonicBorrowSpeeds(tTokenAddress);
    }
    async tonicDailyDistributeRateForSupply(tTokenAddress) {
        // TODO: Check if token is supported
        const tCore = this.getTectonicCore();
        const tonicSpeedPerBlock = await tCore.tonicSupplySpeeds(tTokenAddress);
        return tonicSpeedPerBlock.mul(bignumber_1.BigNumber.from(constant_1.TectonicConst.BLOCKS_PER_DAY));
    }
    async tonicDailyDistributeRateForBorrow(tTokenAddress) {
        // TODO: Check if token is supported
        const tCore = this.getTectonicCore();
        const tonicSpeedPerBlock = await tCore.tonicBorrowSpeeds(tTokenAddress);
        return tonicSpeedPerBlock.mul(bignumber_1.BigNumber.from(constant_1.TectonicConst.BLOCKS_PER_DAY));
    }
    async claim(claimantAddress) {
        const tCore = this.getTectonicCore();
        // const gasLimit = await tCore.estimateGas["claimTonic(address)"](claimantAddress);
        return (0, util_1.wrapSdkTransaction)(tCore['claimTonic(address)'](claimantAddress));
    }
    async claimTonicFromHelper(claimantAddress, tectonicCores, tectonicBoostAddress, depositPercentage, vaultPoolId) {
        const tonic = super.getTonic();
        const tLens = this.getContractByName('TectonicLens');
        const tectonicBoostContract = this.getContractByName('TectonicBoost');
        let validTectonicCores;
        validTectonicCores = tectonicCores.slice();
        for (let i = 0; i < tectonicCores.length; i++) {
            let extData = await tLens.callStatic.getTonicBalanceMetadataExt(tonic.address, tectonicCores[i], claimantAddress);
            if (extData.allocated.eq(0)) {
                let sliceIndex = validTectonicCores.indexOf(tectonicCores[i]);
                validTectonicCores.splice(sliceIndex, 1);
            }
        }
        let unClaimTonicBoostAmount = await tectonicBoostContract.callStatic.unClaimTonic(claimantAddress);
        if (!unClaimTonicBoostAmount.isZero()) {
            validTectonicCores.push(tectonicBoostAddress);
        }
        const claimHelper = this.getClaimTokenHelper();
        return (0, util_1.wrapSdkTransaction)(claimHelper['claimTonic(address,address[],uint256,uint256)'](claimantAddress, validTectonicCores, depositPercentage, vaultPoolId));
    }
    async claimNonTonicTokenFromHelper(partnerTokenAddress, claimantAddress, tokenRewarders) {
        const claimHelper = this.getClaimTokenHelper();
        let validTokenRewarders;
        validTokenRewarders = tokenRewarders.slice();
        for (let i = 0; i < tokenRewarders.length; i++) {
            let [unclaimedAmount] = await claimHelper.callStatic.getUnclaimedPartnerTokensForUser(claimantAddress, [partnerTokenAddress], [tokenRewarders[i]]);
            if (unclaimedAmount.eq(0)) {
                let sliceIndex = validTokenRewarders.indexOf(tokenRewarders[i]);
                validTokenRewarders.splice(sliceIndex, 1);
            }
        }
        return (0, util_1.wrapSdkTransaction)(claimHelper.claimNonTonicToken(partnerTokenAddress, claimantAddress, tokenRewarders));
    }
    async claimNonTonicTokensFromHelper(partnerTokenAddresses, claimantAddress, tokenRewarders) {
        const claimHelper = this.getClaimTokenHelper();
        return (0, util_1.wrapSdkTransaction)(claimHelper.claimNonTonicTokens(partnerTokenAddresses, claimantAddress, tokenRewarders));
    }
    async getNonTonicTokenListAndUnclaimedAmount(claimantAddress, tokenRewarders) {
        const claimHelper = this.getClaimTokenHelper();
        const signerOrProvider = this.walletNotConnected
            ? this.provider
            : this.signer;
        let partnerTokens = [];
        let partnerTokenList = [];
        let checkDuplicate = new Map();
        for (let i = 0; i < tokenRewarders.length; i++) {
            let tokenRewarder = tectonic_contract_types_1.TokenRewarderFactory.connect(tokenRewarders[i], signerOrProvider);
            let partnerTokenSubList = await tokenRewarder.getPartnerTokenList();
            for (let j = 0; j < partnerTokenSubList.length; j++) {
                // check duplicate partner token
                if (checkDuplicate.get(partnerTokenSubList[j])) {
                    continue;
                }
                checkDuplicate.set(partnerTokenSubList[j], true);
                const partnerTokenContract = this.getContractByAddressAndType(partnerTokenSubList[j], 'EIP20Interface');
                const name = await partnerTokenContract.name();
                const symbol = await partnerTokenContract.symbol();
                const decimals = await partnerTokenContract.decimals();
                partnerTokens.push({
                    address: partnerTokenSubList[j],
                    name: name,
                    symbol: symbol,
                    decimals: decimals,
                });
                partnerTokenList.push(partnerTokenSubList[j]);
            }
        }
        let unclaimedAmounts = await claimHelper.callStatic.getUnclaimedPartnerTokensForUser(claimantAddress, partnerTokenList, tokenRewarders);
        let balances = [];
        for (let i = 0; i < partnerTokens.length; i++) {
            const partnerTokenContract = this.getContractByAddressAndType(partnerTokens[i].address, 'EIP20Interface');
            balances.push(await partnerTokenContract.balanceOf(claimantAddress));
        }
        return { partnerTokens, unclaimedAmounts, balances };
    }
    async estimateTonic(claimantAddress) {
        const tonic = super.getTonic();
        const tLens = this.getContractByName('TectonicLens');
        const extData = await tLens.callStatic.getTonicBalanceMetadataExt(tonic.address, this.getTectonicCore().address, claimantAddress);
        // console.log(extData);
        return extData.allocated;
    }
    async estimateTonicInBatch(tectonicCores, claimantAddress) {
        const tonic = super.getTonic();
        const tLens = this.getContractByName('TectonicLens');
        let result = bignumber_1.BigNumber.from(0);
        for (let i = 0; i < tectonicCores.length; i++) {
            let extData = await tLens.callStatic.getTonicBalanceMetadataExt(tonic.address, tectonicCores[i], claimantAddress);
            result = result.add(extData.allocated);
        }
        return result;
    }
    async claimFromAirDropper(amount, signature) {
        const tonicAirDropper = this.getContractByName('TonicAirDropper');
        return (0, util_1.wrapSdkTransaction)(tonicAirDropper.claimTonic(bignumber_1.BigNumber.from(amount), signature));
    }
    async airDropClaimed(claimantAddress) {
        const tonicAirDropper = this.getContractByName('TonicAirDropper');
        return await tonicAirDropper.isClaimed(claimantAddress);
    }
    async nonTonicDistributeRateForSupply(tTokenAddress) {
        const tokenRewarder = this.getTokenRewarder();
        const partnerTokenList = await tokenRewarder.getPartnerTokenList();
        let rates = [];
        for (let i = 0; i < partnerTokenList.length; i++) {
            let nonTonicSpeedPerBlock = await tokenRewarder.supplySpeeds(partnerTokenList[i], tTokenAddress);
            if (nonTonicSpeedPerBlock.eq(bignumber_1.BigNumber.from(0))) {
                continue;
            }
            rates.push({
                partnerToken: partnerTokenList[i],
                rate: nonTonicSpeedPerBlock,
            });
        }
        return rates;
    }
    async nonTonicDistributeRateForBorrow(tTokenAddress) {
        const tokenRewarder = this.getTokenRewarder();
        const partnerTokenList = await tokenRewarder.getPartnerTokenList();
        let rates = [];
        for (let i = 0; i < partnerTokenList.length; i++) {
            let nonTonicSpeedPerBlock = await tokenRewarder.borrowSpeeds(partnerTokenList[i], tTokenAddress);
            if (nonTonicSpeedPerBlock.eq(bignumber_1.BigNumber.from(0))) {
                continue;
            }
            rates.push({
                partnerToken: partnerTokenList[i],
                rate: nonTonicSpeedPerBlock,
            });
        }
        return rates;
    }
    async nonTonicDailyDistributeRateForSupply(tTokenAddress) {
        const tokenRewarder = this.getTokenRewarder();
        const partnerTokenList = await tokenRewarder.getPartnerTokenList();
        let rates = [];
        for (let i = 0; i < partnerTokenList.length; i++) {
            let nonTonicSpeedPerBlock = await tokenRewarder.supplySpeeds(partnerTokenList[i], tTokenAddress);
            if (nonTonicSpeedPerBlock.eq(bignumber_1.BigNumber.from(0))) {
                continue;
            }
            let dailyRate = nonTonicSpeedPerBlock.mul(bignumber_1.BigNumber.from(constant_1.TectonicConst.BLOCKS_PER_DAY));
            rates.push({ partnerToken: partnerTokenList[i], rate: dailyRate });
        }
        return rates;
    }
    async nonTonicDailyDistributeRateForBorrow(tTokenAddress) {
        const tokenRewarder = this.getTokenRewarder();
        const partnerTokenList = await tokenRewarder.getPartnerTokenList();
        let rates = [];
        for (let i = 0; i < partnerTokenList.length; i++) {
            let nonTonicSpeedPerBlock = await tokenRewarder.borrowSpeeds(partnerTokenList[i], tTokenAddress);
            if (nonTonicSpeedPerBlock.eq(bignumber_1.BigNumber.from(0))) {
                continue;
            }
            let dailyRate = nonTonicSpeedPerBlock.mul(bignumber_1.BigNumber.from(constant_1.TectonicConst.BLOCKS_PER_DAY));
            rates.push({ partnerToken: partnerTokenList[i], rate: dailyRate });
        }
        return rates;
    }
    async getPartnerTokenList() {
        const tokenRewarder = this.getTokenRewarder();
        const partnerTokenList = await tokenRewarder.getPartnerTokenList();
        let partnerTokens = [];
        for (let i = 0; i < partnerTokenList.length; i++) {
            const partnerTokenContract = this.getContractByAddressAndType(partnerTokenList[i], 'EIP20Interface');
            const name = await partnerTokenContract.name();
            const symbol = await partnerTokenContract.symbol();
            const decimals = await partnerTokenContract.decimals();
            partnerTokens.push({
                address: partnerTokenList[i],
                name: name,
                symbol: symbol,
                decimals: decimals,
            });
        }
        return partnerTokens;
    }
}
exports.default = TonicModule;
//# sourceMappingURL=tonic.js.map